<script setup>
import SettingsPage from '@/Pages/Settings.vue'

import { useForm } from '@inertiajs/inertia-vue3';
import { Inertia } from '@inertiajs/inertia'

const props = defineProps({
    /** ManageAdminUsers props */
    adminUsers: {
        type: Object,
        default: () => ({}),
    },
    /** ConnectXero props */
    connected: {
        type: Boolean,
        default: false,
    },
    error: {
        type: Object,
        default: null,
    },
    organisationName: {
        type: String,
        default: null,
    },
    username: {
        type: String,
        default: null,
    },
    authRoute: {
        type: String,
        default: null,
    },
    auth: {
        type: Object,
        default: {},
    },
	xeroSettings: {
		type: Object,
		required: true,
	},
});

const xeroSettingsForm = useForm(props.xeroSettings);

</script>

<template>
	<SettingsPage 
		:admin-users="adminUsers"
		:connected="connected"
		:error="error"
		:organisation-name="organisationName"
		:username="username"
		:auth-route="authRoute"
		:xero-settings="xeroSettingsForm"
	/>
</template>